import { createStrokePatternsContext } from './stroke-patterns-context-factory';

const { StrokePatternsContext, useStrokePatternsContext } = createStrokePatternsContext(
  'RunSetsStrokePatternsContextProvider',
);

export const RunSetsStrokePatternsContext = StrokePatternsContext;
export const useRunSetsStrokePatternsContext = useStrokePatternsContext;
